"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainMetrics = exports.Chain = void 0;
Object.defineProperty(exports, "getAddress", {
  enumerable: true,
  get: function () {
    return _address.getAddress;
  }
});
var _address = require("@ethersproject/address");
var _ChainClient = require("./ChainClient");
var _ProviderFactory = require("./ProviderFactory");
var _cache = require("@blockwell/cache");
var _Metrics = require("./Metrics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChainMetrics = exports.ChainMetrics = new _Metrics.Metrics();
const Chain = exports.Chain = new _ChainClient.ChainClient(_ProviderFactory.standardProviderFactory, new _cache.MemoryCache(60 * 60 * 1000), ChainMetrics);

//@ts-ignore
if (typeof window !== "undefined") {
  Promise.resolve().then(() => _interopRequireWildcard(require("@blockwell/cache/lib/LocalForageCache"))).then(({
    LocalForageCache
  }) => {
    Chain.replaceCache(new LocalForageCache("chain", 60 * 60 * 24 * 30 * 1000));
  });
}
//# sourceMappingURL=Chain.js.map